// extracted by mini-css-extract-plugin
export default {"aboutPage":"AboutStyles_aboutPage__xBnZ0","info":"AboutStyles_info__7eU7e","lightTheme":"AboutStyles_lightTheme__nJwbR","darkTheme":"AboutStyles_darkTheme__f-4Rm"};